import React from 'react'
import Link from 'gatsby-link'

const Instructions = () => (
  <div>
    <h2>How to use</h2>
    <p>In your HTML/CSS:</p>
    <ol>
      <li><p>Make a table.</p></li>
      <li><p>Ensure that the the table cells that you want to stick in place have backgrounds and borders <i>defined directly on them</i>. <b>Not on the rows, but on the cells themselves.</b></p>
        <p>Example:</p>
        <pre>{`// Correct
td {
  background: gray;
}

// Incorrect
tr {
  background: gray;
}`}</pre>
      </li>
      <li><p>Wrap the table in some containing element like a &lt;div&gt;, and make sure the &lt;div&gt; has height, width, and overflow specified correctly so the table can be scrolled if it is too large for its container.</p></li>
      <li>
        <p>Add classes to the cells that you want to stick in place.</p>
        <dl>
          <dt><code>.sns---is-stuck</code></dt>
          <dd>Ensures the cell does not move at all when scrolled, in either vertical or horizontal directions</dd>
          <dt><code>.sns--is-stuck-x</code></dt>
          <dd>Cell can be scrolled vertically, but not horizontally</dd>
          <dt><code>.sns--is-stuck-y</code></dt>
          <dd>Cell can be scrolled horizontally, but not vertically</dd>
        </dl>
      </li>
    </ol>
    <p>In your javascript:</p>
    <ol start="5">
      <li><p>Install Stick-n-Slide <code>npm install stick-n-slide</code>.</p></li>
      <li><p>Import Stick-n-Slide into your codebase <code>import stickNSlide from 'stick-n-slide'</code>.</p></li>
      <li>
        <p>Get a reference to your table(s), either via native JS or jQuery.</p>
        <p>Example:</p>
        <pre>{`// Native JS
const tableElements = document.querySelectorAll('.my-tables');

// jQuery
const tableElements = $('.my-tables');
`}</pre>
      </li>
      <li>
        <p>Call <code>stickNSlide(tableElements)</code> on the tables whose cells you want to stick in place.</p>
        {
          /*
            <p>Options may include:</p>
            <dl>
              <dt><code>showShadow</code> - Boolean</dt>
              <dd>Shows a small shadow offset from the stuck elements</dd>
            </dl>
          */
        }
      </li>
    </ol>
  </div>
)

export default Instructions




// WEBPACK FOOTER //
// ./src/components/stick-n-slide/instructions.jsx